import React from "react";
import {Button, Form} from "antd";
import * as Yup from 'yup';
import {Formik} from "formik";
import {TextAreaInput, TextInput} from "../../Boilerplate/formikComponents";
import {cloneDeep} from "lodash";

export const ListForm = props => {
  const { list, onCancel, onSubmit } = props;
  let initials = {};
  if (list) initials = cloneDeep(list);
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    }
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 8,
      },
    },
  };
  return (
    <Formik
      initialValues={initials}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit && onSubmit(values);
      }}
      validationSchema={Yup.object().shape({
        id: Yup.string().nullable(),
        name: Yup.string().required(),
        description: Yup.string().required(),
      })}
    >
      {props => {
        const {
          // eslint-disable-next-line
          values, touched, errors, isSubmitting, handleChange, handleBlur, dirty,
          handleSubmit,
          handleReset,
        } = props;
        return (
          <Form>
            <TextInput {...props} formItemLayout={formItemLayout} label='Name' name='name' placeholder='Enter a title'/>
            <TextAreaInput {...props} formItemLayout={formItemLayout} label='Description' name='description'
                           placeholder='Contact list description'/>

            <Form.Item className='submit-controls' {...tailFormItemLayout}>
              <Button.Group compact>
                <Button onClick={handleSubmit} type='primary'>Save</Button>
                <Button onClick={handleReset}>Clear</Button>
                <Button onClick={onCancel}>Cancel</Button>
              </Button.Group>
            </Form.Item>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ListForm;



// WEBPACK FOOTER //
// ./src/components/Settings/ContactLists/ListForm.js